import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { LOGOUT_ROUTE } from "../../constants/routes";
import { accountThunkActions } from "../../redux/actions/account";
import { commonActions } from "../../redux/actions/common";
import { IAppState } from "../../redux/reducers";
import {
  SidePanel,
  SidePanelPosition,
} from "../shared-ui/side-panel/side-panel";
import styles from "./right-nav.module.scss";
import { NavLink } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";

const mapStateToProps = (state: IAppState) => ({
  userName: state.users.currentUser.name,
  isOpen: state.common.isRightNavOpen,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    logout: () => {
      dispatch(accountThunkActions.logout());
    },
    startLoading: () => dispatch(commonActions.startLoading()),
  };
};

interface IRightNavProps
  extends ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

const RightNav = connect(
  mapStateToProps,
  mapDispatchToProps
)((props: IRightNavProps) => {
  return (
    <SidePanel
      side={SidePanelPosition.Right}
      open={props.isOpen}
      className={styles.root}
      rootClass={styles["side-panel"]}
      testId="right-nav"
    >
      <div className={styles.name}>
        <div>You are logged in as:</div>
        <NavLink
          data-testid="navbar-link-profile"
          to={""}
          className={styles["nav-link"]}
        >
          <PersonIcon className={styles.icon} />
          <span className={styles["account-name"]}>{props.userName}</span>
        </NavLink>
      </div>
      <div className={styles.logout}>
        <a
          data-testid="navbar-link-logout"
          onClick={() => props.startLoading()}
          href={LOGOUT_ROUTE}
          className={styles["logout__link"]}
        >
          <PowerSettingsNewIcon className={styles.icon} />
          Logout
        </a>
      </div>
    </SidePanel>
  );
});

export default RightNav;
